import React from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';


class Papers extends React.Component {
    render() {
        return (
            <div className='biopage'>
                <Header />
                <div className="page-people" >
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container gloss_container">
                                <div>
                                    <h1 className="construct-heading heading">CIS Working Papers</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content listing">
                        <div className="container ">
                            <div className="row">
                                <div className="region region-content">
                                    <div className="listings">
                                        <h5 style={{ color: 'grey', marginLeft: '7px' }}>Under Construction</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Footer />
                </div>
            </div>
        )
    }
}
export default Papers;